import React from 'react'
import { Switch, Route } from "react-router-dom"
import Pages from './pages.page'
import CreatePage from './create/create.page'
import EditPage from './edit/edit.page'

const PageController = () => {
    return (
        <Switch>
            <Route path="/journal/pages/edit/:id" component={EditPage} />
            <Route path="/journal/pages/create" component={CreatePage} />
            <Route exact path="/journal/pages" component={Pages} />
            <Route path="/journal/pages/:id" component={Pages} />
        </Switch>
    )
}

export default PageController